export default "__VITE_ASSET__D5Z0yn4l__"